import React, { useState } from 'react';
import SEO from './shared/SEO';
import PageLayout from './layout/PageLayout';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import faqItems from '../data/faqQuestions';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <SEO
        title="FAQ | COTAD"
        description="Frequently asked questions about COTAD and our services."
        pathname="/faq"
      >
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </SEO>

      <PageLayout
        title="Frequently Asked Questions"
        description="Find answers to common questions about COTAD and our services."
      >
        <section className="py-12 max-w-3xl mx-auto px-4">
          <div className="space-y-4">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className="border border-border rounded-lg overflow-hidden bg-bg-secondary"
              >
                <button
                  onClick={() => toggleQuestion(index)}
                  className="w-full text-left px-6 py-4 flex justify-between items-center hover:bg-hover transition-colors"
                >
                  <h2 className="text-lg font-medium text-text-primary">
                    {item.question}
                  </h2>
                  <ChevronDownIcon 
                    className={`w-5 h-5 text-accent transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    openIndex === index ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <div className="px-6 py-4 text-text-secondary border-t border-border">
                    <p>{item.answer}</p>
                    {item.link && (
                      <a 
                        href={item.link}
                        className="inline-block mt-2 text-accent hover:text-accent-hover underline transition-colors"
                      >
                        Learn more →
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </PageLayout>
    </>
  );
};

export default FAQ;